import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Carousel from "./Carousel";
import Accordion from "./Accordion";
import kmLogo from "./images/km-logo.png";
import rxLogo from "./images/RX-ca-logo.png";
import vpccLogo from "./images/vpcc-logo.png";
import rxImageOne from "./images/rx-ca-1.png";
import rxImageTwo from "./images/rx-ca-2.png";
import rxImageThree from "./images/rx-ca-3.png";
import "./styles.css";

const RxLanding = () => {
  useEffect(() => {
    // Microsoft Clarity
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", "ubiy3fq09m");
  }, []);

  const slides = [
    {
      type: "video",
      src: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/vpcc-images/RX-Murali-X-KM.mp4",
    },
    {
      type: "video",
      src: "https://km-landing.s3.ap-south-1.amazonaws.com/Images/vpcc-x-rx-ca.mp4",
    },
    { type: "image", src: rxImageOne },
    { type: "image", src: rxImageTwo },
    { type: "image", src: rxImageThree },
  ];

  return (
    <>
      <header style={{ width: "100%" }}>
        <div>
          <Link to="/">
            <img className="km-logo" src={kmLogo} alt="khelomore-logo" />
          </Link>
        </div>
      </header>

      <main>
        {/* HERO SECTION */}
        <section className="full-width-section">
          <div className="container">
            <div className="flex center-align">
              <div>
                <img
                  className="rx-ca-logo mt-48 ml-16 mr-32"
                  src={rxLogo}
                  alt="RX-Cricket-Academy-Logo"
                />
              </div>
              <div>
                <img
                  className="vpcc-logo mt-48 ml-16 mr-32"
                  src={vpccLogo}
                  alt="vpcc-logo"
                />
              </div>
              <div>
                <img
                  className="km-logo-two mt-48"
                  src={kmLogo}
                  alt="khelomore-logo"
                />
              </div>
            </div>

            <div className="text-hero-bg display-ib mt-96">
              <h1 className="main-text">
                Elite Coaching for the Cricketer Within You.
              </h1>
            </div>

            <div className="mt-48 relative">
              <a
                className="link-btn"
                href="https://rzp.io/rzp/WKvOrKth"
                target="_blank"
                rel="noreferrer"
                onClick={() => {
                  window.fbq("track", "Subscribe", {
                    academy: "VPCC x RX Cricket Academy",
                  });
                }}
              >
                <button className="primary-btn link-pd">
                  Book your Trial at ₹99
                </button>
              </a>
            </div>
          </div>
        </section>

        {/* INTRO TEXT */}
        <section className="mtb-64 ml-96">
          <h2 className="train-best">
            Want to hit harder, bowl sharper, and play smarter?
          </h2>
          <p className="train-sub-text mt-32">
            Train at KheloMore’s partner academy in Hoodi — with structured
            programs, expert <br className="hide-mob" />
            mentors, and world-class facilities designed to take you from casual
            cricketer to confident player.
          </p>
        </section>

        {/* WHY CHOOSE US */}
        <section className="why-us">
          <div className="flex center-align ml-96">
            <h2 className="train-best why-vpcc">Why Choose Us ?</h2>
            <div className="hr-line"></div>
          </div>

          <div className="flex center-align space-bw mt-48">
            <div className="trial-box">
              <p className="train-sub-text trial-text fw300">
                <span className="train-strong-text fw400">
                  {" "}
                  Structured training{" "}
                </span>
                for every level - beginner to advanced.
              </p>
            </div>
            <div>
              <span className="number display-ib nm-ab1">1</span>
            </div>
          </div>

          <div className="flex center-align space-bw mt-48">
            <div>
              <span className="number display-ib nm-ab2">2</span>
            </div>
            <div className="trial-box">
              <p className="train-sub-text trial-text fw300">
                <span className="train-strong-text fw400">
                  {" "}
                  Expert coaches{" "}
                </span>
                with national and professional experience.
              </p>
            </div>
          </div>

          <div className="flex center-align space-bw mt-48">
            <div className="trial-box">
              <p className="train-sub-text trial-text fw300">
                <span className="train-strong-text fw400">
                  {" "}
                  Holistic focus{" "}
                </span>
                on fitness, skill development, and progress tracking.
              </p>
            </div>
            <div>
              <span className="number display-ib nm-ab1">3</span>
            </div>
          </div>

          <div className="flex center-align space-bw mt-48">
            <div>
              <span className="number display-ib nm-ab2">4</span>
            </div>
            <div className="trial-box">
              <p className="train-sub-text trial-text fw300">
                <span className="train-strong-text fw400">
                  {" "}
                  Elite facilities{" "}
                </span>
                - turf wickets, bowling machines, indoor & outdoor nets.
              </p>
            </div>
          </div>
        </section>

        {/* TABLE SECTION */}
        <section>
          <div className="table-container ml-96 mr-96">
            <table className="custom-table mTb-64">
              <thead>
                <tr>
                  <th className="center-col">Academy</th>
                  <th className="center-col">Location</th>
                  <th className="center-col">Age Group</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="venue-col">
                    <div className="venue-wrap space-bw">
                      <span className="venue-name">
                        VPCC x RX Cricket Academy
                      </span>
                      <button className="book-btn">
                        <a
                          href="https://rzp.io/rzp/WKvOrKth"
                          target="_blank"
                          rel="noreferrer"
                          onClick={() => {
                            window.fbq("track", "Subscribe", {
                              academy: "VPCC x RX Cricket Academy",
                            });
                          }}
                        >
                          Book Now
                        </a>
                      </button>
                    </div>
                  </td>
                  <td className="center-col">
                    Seetharamplaya Whitefield, Bangalore
                  </td>
                  <td className="center-col">5 Years - 25 Years old</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* ONE ACADEMY ONE MISSION */}
        <section>
          <div className="flex center-align ml-96 mt-48">
            <div>
              <h2 className="train-best why-vpcc">One Academy. One Mission.</h2>
            </div>
            <div className="hr-line"></div>
          </div>
        </section>

        {/* RX CAROUSEL */}
        <section className="mt-96">
          <div className="ml-96 mt-48">
            <h2 className="train-best">RX Cricket Academy</h2>
            <span className="address">Mahadevapura, Bangalore</span>
          </div>

          <Carousel slides={slides} />
        </section>

        {/* ACCORDION */}
        <Accordion />

        {/* CTA */}
        <section className="flex space-bw center-align ml-96 mt-96 mr-96 flex-col-mob">
          <div>
            <h2 className="train-best">Ready to Take Your Game Up a Notch?</h2>
            <span className="why-text mt-16 display-block mt8-mob">
              See the difference for yourself with a trial session.
            </span>
          </div>
          <a
            href="https://rzp.io/rzp/WKvOrKth"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              window.fbq("track", "Subscribe", {
                academy: "VPCC x RX Cricket Academy",
              });
            }}
          >
            <button className="primary-btn link-pd-2 mt24-mob">
              Book your Trial at ₹99
            </button>
          </a>
        </section>
      </main>

      <footer className="mt-96" style={{ paddingBottom: 24 }}>
        <p className="center footer-text">
          © 2026 KHELOMORE SPORTS PRIVATE LIMITED. ALL RIGHTS RESERVED.
        </p>
      </footer>
    </>
  );
};

export default RxLanding;
